import { getEnv, getEnvString } from '@core/lib/utils/getEnv';

// List of routes where we don't show environment-banner.
// It's needed for pages fully based on Atlas.
const NO_BANNER_ROUTES = ['conversionValueManager'];

function environmentBanner() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./environment-banner.html'),
    scope: {},
    controllerAs: 'vm',
    controller: 'EnvironmentBannerController',
  };
}

function EnvironmentBannerController(configuration, $transitions) {
  'ngInject';
  var vm = this;
  const env = getEnv();
  const allowedEnv = env.development || env.qa;

  vm.environment = `ENV: ${getEnvString(process.env.STAGE)} - API: ${configuration.environment}`;
  vm.show = false;

  $transitions.onSuccess({}, _handleChangeSuccess);

  function _handleChangeSuccess(tr) {
    const newRoute = tr.to().name;
    const isAllowedNewRoute = !NO_BANNER_ROUTES.some(route => newRoute.includes(route));

    vm.show = allowedEnv && isAllowedNewRoute;
  }
}

export { EnvironmentBannerController, environmentBanner };
